import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { contactUs, contactUsUpdateStatus } from "../apis/apiHandler";

export const contactUsList = createAsyncThunk(
    "ContactUs/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await contactUs(payload);
            if (response?.code === 1 || response?.code === 2) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateContactUsStatus = createAsyncThunk(
    "ContactUs/updateStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await contactUsUpdateStatus(payload);
            if (response?.code === 1) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    contactUsList: [],
    updateStatusData: {},
    error: null,
    success: false,
};

const contactUsSlice = createSlice({
    name: "contactUs",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(contactUsList.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(contactUsList.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.contactUsList = payload;
                state.success = true;
            })
            .addCase(contactUsList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateContactUsStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(updateContactUsStatus.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateStatusData = payload;
                state.success = true;
            })
            .addCase(updateContactUsStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            });
    },
});

export default contactUsSlice.reducer;
